import { Table } from "react-bootstrap";
import { DigitalInput } from "../../../models/digitalinput";
import StationStatusRow from "./StationStatusRow";

interface Props {
  digitalInputs: DigitalInput[];
}

const StationStatusTable = ({ digitalInputs }: Props) => {
  return (
    <Table responsive striped hover>
      <thead>
        <tr>
          <th scope="col">Point</th>
          <th scope="col">Name</th>
          <th scope="col">State</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        {digitalInputs.map((digitalInput) => (
          <StationStatusRow
            key={digitalInput.Point}
            digitalInput={digitalInput}
          />
        ))}
      </tbody>
    </Table>
  );
};

export default StationStatusTable;
